export default __webpack_public_path__ + "static/media/runtimescreen.c944044b.png";